export default __webpack_public_path__ + "static/media/4.d8532b48.jpg";